import { Button, Col, Divider, Dropdown, Menu, Row, Select } from 'antd'
import React, { useEffect } from 'react'
import { CaretDownOutlined } from '@ant-design/icons';
import { Line } from 'react-chartjs-2';
import { useState } from 'react';
import api from '../utils/apiRoutes';
import Cookies from 'js-cookie';
import GlobalLoading from '../Containers/GlobalLoading';

const NestedCircularGraph = ({ data }) => {
    const radius = 130;
    const strokeWidth = 7;
    const circles = data.map((item, index) => {
    const circumference = 2 * Math.PI * (radius - ((index+1) * strokeWidth));
    const strokeDashoffset = ((100 - item.percent) / 100) * circumference;
    return (
      <>
      <circle
        className="circle-stroke"
        cx={radius}
        cy={radius}
        r={radius - ((index+1) * (strokeWidth + 26))/2}
        fill="transparent"
        stroke="#F6F6F6"
        strokeWidth={strokeWidth}
      />
      <circle
        key={index}
        className="circle-stroke"
        cx={radius}
        cy={radius}
        r={radius - ((index+1) * (strokeWidth + 26))/2}
        fill="transparent"
        stroke={item.color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap='round'
      />
      </>
    );
  });

  return (
    <svg className="nested-circular-graph" width={radius*2} height={radius*2} viewBox={`0 0 ${radius * 2} ${radius * 2}`} style={{rotate:'-90deg'}}>
      {circles}
    </svg>
  );
};

function PatientStats() {

  // const stats = {
  //   raise: 125,
  //   approved: 105,
  //   declined: 20,
  //   admitted: 90,
  //   discharged: 60
  // }

  const options = {
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false
      },
    },
    borderWidth: 1,
    scales: {
      x: {
        display: false,
        ticks: {
          beginAtZero: false
        },
      },
      y: {
        ticks: {
          display: false,
          beginAtZero: false
        },
        grid: {
          display: false,
          color: '#4CB87A',
          borderColor: '#4CB87A',
          borderWidth: 3
        }
      }
    }
  }
  const optionsDischarged = {
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false
      },
    },
    borderWidth: 1,
    scales: {
      x: {
        display: false,
      },
      y: {
        ticks: {
          display: false
        },
        grid: {
          display: false,
          color: '#43A3E8',
          borderColor: '#43A3E8',
          borderWidth: 3,
        }
      },
    }
  }

  const labels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
  ];

  const data = {
    labels: labels,
    datasets: [{
      backgroundColor: '#4CB87A',
      borderColor: '#4CB87A',
      data: [21, 23, 53, 89, 120, 134, 145],
    }]
  };

  const dataDischarged = {
    labels: labels,
    datasets: [{
      backgroundColor: '#43A3E8',
      borderColor: '#43A3E8',
      data: [21, 23, 53, 89, 120, 134, 145],
    }]
  };

  const [filters, setFilters] = useState({ date: '', location: '' });
  const [stats, setStats] = useState({
    raised: 0,
    approved: 0,
    declined: 0,
    admitted: 0,
    discharged: 0,
  });
  const [loading, setLoading] = useState(false);

  const onClickDate = (e) => {
    // console.log(e.key, 'here');
    setFilters({ ...filters, date: e.key });
  };
  const onClickLocation = (e) => {
    // console.log(e.key, 'here');
    setFilters({ ...filters, location: e.key });
  };

  useEffect(() => {
    const headers = { 'Authorization': `Bearer ${Cookies.get('token_medical_auth')}` }
    // console.log({new_header:headers});
    setLoading(true);
    // console.log({ headers });
    api.patientsStats.getPatientStats({}, headers, filters).then(res => {
      setStats({...res.data,raised:(res.data.approved+res.data.declined+res.data.others)});
      setLoading(false);
    }).catch(err => {
      console.log(err);
      setLoading(false);
    })

  }, [filters])

  const menu = (
    <Menu
      onClick={onClickDate}
      items={[
        {
          key: '',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              All dates
            </a>
          ),
        },
        {
          key: 'Today',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Today
            </a>
          ),
        },
        {
          key: 'This week',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com" onClick={(e) => { e.preventDefault() }}>
              This week
            </a>
          ),
        },
        {
          key: 'This month',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com" onClick={(e) => { e.preventDefault() }}>
              This month
            </a>
          ),
        },
      ]}
    />
  );

  const menuLocation = (
    <Menu
      onClick={onClickLocation}
      items={[
        {
          key: '',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              All locations
            </a>
          ),
        },
        {
          key: 'Delhi',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Delhi
            </a>
          ),
        },
        {
          key: 'Mumbai',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Mumbai
            </a>
          ),
        }
      ]}
    />
  );

  if (loading) return <GlobalLoading />

  // return (
  //   <div className="real-stats-container">
  //     <div className="stats-box">
  //       <Row justify="space-between">
  //         <Col span={14}><h5>Real Time Patient Status</h5></Col>
  //         <Col span={10}>
  //           <Row justify="end">
  //             <Col style={{ marginRight: 5 }}>
  //               <Dropdown overlay={menu} placement="bottom">
  //                 <Button>{filters.date === '' ? 'Date' : filters.date} <CaretDownOutlined style={{color:'#3788E5'}} /></Button>
  //               </Dropdown>
  //             </Col>
  //             {/* <Col >
  //               <Dropdown overlay={menuLocation} placement="bottom">
  //                 <Button>{filters.location === '' ? 'Location' : filters.location} <CaretDownOutlined /></Button>
  //               </Dropdown>
  //             </Col> */}
  //           </Row>
  //         </Col>
  //       </Row>
  //       <Row className="stats-info-container" gutter={24}>
  //         <Col className="stats-rings-patient" span={6}>
  //           <div className='raised container'>
  //             <div className={`admitted container value${Math.floor((stats.admitted*100/stats.raised)) || 0}`}>

  //             </div>
  //           </div>
  //           {/* <div className="wrapper">
  //             <div className={`c100 p100 yellow`}>
  //               <div className="slice">
  //                 <div className="bar"></div>
  //                 <div className="fill"></div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="admitted wrapper">
  //             <div className={`c100 p${Math.floor((stats.admitted*100/stats.raised)) || 0} blue`}>
  //               <div className="slice">
  //                 <div className="bar"></div>
  //                 <div className="fill"></div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="approved wrapper">
  //             <div className={`c100 p${(Math.floor(stats.approved * 100 / stats.raised)) || 0} green`}>
  //               <div className="slice">
  //                 <div className="bar"></div>
  //                 <div className="fill"></div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="declined wrapper">
  //             <div className={`c100 p${(Math.floor(stats.declined * 100 / stats.raised)) || 0} red`}>
  //               <div className="slice">
  //                 <div className="bar"></div>
  //                 <div className="fill"></div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="others wrapper">
  //             <div className={`c100 p${Math.floor((stats.others * 100 / stats.raised)) || 0} light-blue`}>
  //               <div className="slice">
  //                 <div className="bar"></div>
  //                 <div className="fill"></div>
  //               </div>
  //             </div>
  //           </div> */}
  //         </Col>
  //         <Col className="stats-content" span={18}>
  //           <Row gutter={24}>
  //             <Col span={6}>
  //               <h6>Raised</h6>
  //               <span className="pre-auth raised">{stats.raised}</span>
  //               <p>Patients</p>
  //             </Col>
  //             <Col span={6}>
  //               <h6>Approved</h6>
  //               <span className="pre-auth approved">{stats.approved}</span>
  //               <p>Patients</p>
  //             </Col>
  //             <Col span={6}>
  //               <h6>Rejected</h6>
  //               <span className="pre-auth declined">{stats.declined}</span>
  //               <p>Patients</p>
  //             </Col>
  //             <Col span={6}>
  //               <h6>Under Process</h6>
  //               <span className="pre-auth others">{stats.others}</span>
  //               <p>Patients</p>
  //             </Col>
  //           </Row>
  //           <Divider />
  //           <Row className="admitted-discharged-container">
  //             <Col span={12} className="stats-col">
  //               <h6>Admitted</h6>
  //               <h5 className="stat green">{stats.admitted}</h5>
  //               <span>Patients</span>
  //             </Col>

  //             <Col span={12} className="stats-col">
  //               <h6>Discharged</h6>
  //               <h5 className="stat blue">{stats.discharged}</h5>
  //               <span>Patients</span>
  //             </Col>
  //           </Row>
  //         </Col>
  //       </Row>
  //     </div>
  //   </div>
  // )

  return (
    <>
    <div className='real-stats-container'>
      <div className='stats-box'>
        <div className='top-bar'>
          <h5>Real Time Patient Status</h5>
          <Dropdown overlay={menu} placement="bottom" getPopupContainer={trigger => trigger.parentElement}>
            <Button>{filters.date === '' ? 'Date' : filters.date} <CaretDownOutlined style={{color:'#3788E5'}} /></Button>
          </Dropdown>
        </div>
        <div className='data-container'>
          <div className='visual-chart'>
              <NestedCircularGraph
              data = {[
                { percent: 100, color: '#E8C463' },
                { percent: (Math.floor((stats.others*100/stats.raised)) || 0), color: '#C5D9FF' },
                { percent: (Math.floor((stats.approved*100/stats.raised)) || 0), color: '#30C118' },
                { percent: (Math.floor((stats.declined*100/stats.raised)) || 0), color: '#F4666F' },
                { percent: (Math.floor((stats.admitted*100/stats.raised)) || 0), color: '#627FB5' },
                { percent: (Math.floor((stats.discharged*100/stats.raised)) || 0), color: '#B2DF8A' },
              ]}
              />
            {/* <div className='raised value100'>
              <div className={`admitted value${Math.floor((stats.admitted*100/stats.raised))}`}>
                <div className={`approved value${Math.floor((stats.approved*100/stats.raised))}`}>
                  <div className={`rejected value${Math.floor((stats.declined*100/stats.raised))}`}>
                    <div className={`under-process value${Math.floor((stats.others*100/stats.raised))}`}>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <div className='chart-data'>
            <div className='individual-data'>
              <div className='flex-col-center'>
                <h5 className='raised'>Raised</h5>
                <h4 className='raised'>{stats.raised}</h4>
                <h6>Patients</h6>
              </div>

              <div className='flex-col-center'>
                <h5 className='approved'>Approved</h5>
                <h4 className='approved'>{stats.approved}</h4>
                <h6>Patients</h6>
              </div>

              <div className='flex-col-center'>
                <h5 className='rejected'>Rejected</h5>
                <h4 className='rejected'>{stats.declined}</h4>
                <h6>Patients</h6>
              </div>

              <div className='flex-col-center'>
                <h5 className='under-process'>Under Process</h5>
                <h4 className='under-process'>{stats.others}</h4>
                <h6>Patients</h6>
              </div>
            </div>
            <Divider style={{borderBottom:'1px solid #E4DFDF', boxShadow:'0 2px 4px #00000040'}}/>
            <div className='total-data'>
              <div className='flex-col-center'>
                <h3 className='admitted'>Admitted</h3>
                <h2 className='admitted'>{stats.admitted}</h2>
                <h5>Patients</h5>
              </div>

              <div className='flex-col-center'>
                <h3 className='discharged'>Discharged</h3>
                <h2 className='discharged'>{stats.discharged}</h2>
                <h5>Patients</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default PatientStats